<template>
  <div>
    <v-container class="pt-0">
      <v-row class="pb-3 mt-2">
        <v-row>
          <v-col cols="12" sm="6" md="6" class="pa-0 pl-6">
            <div class="configuracoesTitulo">Entrega:</div>
            <v-radio-group class="ma-0 pa-0" v-model="configuracoes.tipoEntrega" hide-details>
              <v-radio label="Retirar e entregar" value="X" />
              <v-radio label="Apenas entregar" value="E" />
              <v-radio label="Apenas retirar" value="R" />
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <div class="configuracoesTitulo">Filtros:</div>
            <v-checkbox v-model="configuracoes.filtrar" label="Trabalhar com filtros" hide-details
              class="ma-0 mb-1"></v-checkbox>
            <v-row v-if="configuracoes.filtros">
              <v-col class="pt-0">
                <v-text-field hide-details class="ma-0" maxlength="12" :disabled="!configuracoes.filtrar"
                  v-model="configuracoes.filtros.filtro1" label="Filtro 1 (Marca)"></v-text-field>
              </v-col>
              <v-col class="pt-0">
                <v-text-field hide-details class="ma-0" maxlength="12" :disabled="!configuracoes.filtrar"
                  v-model="configuracoes.filtros.filtro2" label="Filtro 2 (Grupo)"></v-text-field>
              </v-col>
              <v-col class="pt-0">
                <v-text-field hide-details class="ma-0" maxlength="12" :disabled="!configuracoes.filtrar"
                  v-model="configuracoes.filtros.filtro3" label="Filtro 3 (Subgrupo)"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

        </v-row>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="12" sm="6" md="6">
          <div class="configuracoesTitulo">Observação tela inicial:</div>
          <v-text-field class="pt-0" hide-details placeholder="Observação tela inicial"
            v-model="configuracoes.obsTelaInicial"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <div class="configuracoesTitulo">Observação fechamento:</div>
          <v-text-field class="pt-0" hide-details placeholder="Observação fechamento"
            v-model="configuracoes.obsFechamento"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="12" sm="6" md="6">
          <div class="configuracoesTitulo">Mensagem WhatsApp:</div>
          <v-text-field class="pt-0" hide-details placeholder="Mensagem WhatsApp"
            v-model="configuracoes.mensagemWpp"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="5" class="pa-0 pl-3">
          <div class="configuracoesTitulo">
            Permitir venda de produtos com estoque zerado?
          </div>
          <v-radio-group class="ma-0 pa-0" v-model="configuracoes.venderSemEstoque" hide-details>
            <v-radio label="Sim" :value="true" />
            <v-radio label="Não" :value="false" />
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="12" sm="6" md="6" class="pa-0 pl-3">
          <div class="configuracoesTitulo">Utilizar preço 1?</div>
          <v-radio-group class="ma-0 pa-0" v-model="configuracoes.usarPreco1" hide-details>
            <v-radio label="Não" value="N" />
            <v-radio label="Sim, substituindo o preço original do produto" value="S" />
            <v-radio label="Sim, utilizando o preço 1 como preço promocional" value="P" />
          </v-radio-group>
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="6" md="6" class="pa-0 pl-3">
          <div class="configuracoesTitulo">
            Utilizar descrição do SKU como descrição do produto?
          </div>
          <v-radio-group class="ma-0 pa-0" v-model="configuracoes.usarDescricaoSku" hide-details>
            <v-radio label="Não" value="N" />
            <v-radio label="Sim, substituindo a descrição do produto" value="S" />
            <v-radio
              label="Sim, utilizando a descrição do produto com a descrição do SKU (descrição do produto - descrição do SKU)"
              value="A" />
          </v-radio-group>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" class="pa-0 pl-3 mb-5">
          <div class="configuracoesTitulo">Ordenação</div>
          <v-radio-group class="ma-0 pa-0" v-model="configuracoes.ordenacao" hide-details>
            <v-radio label="Descrição" value="D" />
            <v-radio label="Marca" value="M" />
            <v-radio label="Grupo" value="G" />
            <v-radio label="Subgrupo" value="S" />
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="6" md="6" class="pa-0 pl-3 mb-5">
          <div class="configuracoesTitulo">Cores</div>
          <ColorField nome="Cor de fundo" :cor="configuracoes.backgroundColor" @setCor="setBackgroundColor" />
          <ColorField nome="Cor destaque (Botões)" :cor="configuracoes.primaryColor" @setCor="setPrimaryColor" />
          <ColorField nome="Cor promoção (texto que aparece na foto)" :cor="configuracoes.promocaoColor"
            @setCor="setPromocaoColor" />
        </v-col>
        <v-spacer />
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" class="pa-0 pl-3 mb-5">
          <div class="configuracoesTitulo">Modo delivery?</div>
          <v-radio-group class="ma-0 pa-0" v-model="configuracoes.modoDelivery" hide-details row>
            <v-radio label="Não" :value="false" />
            <v-radio label="Sim" :value="true" />
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pa-0 pl-3 mb-5" v-if="configuracoes.usaMercadoPago">
          <div class="configuracoesTitulo">Receber pagamentos:</div>
          <v-radio-group class="ma-0 pa-0" v-model="configuracoes.receberNoSite" hide-details row>
            <v-radio label="Na loja e no site" value="A" />
            <v-radio label="Apenas no site" value="S" />
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" class="pa-0 pl-3 mb-5">
          <div class="configuracoesTitulo">Solicitar e-mail:</div>
          <v-radio-group class="ma-0 pa-0" v-model="configuracoes.solicitarEmail" hide-details>
            <v-radio label="Não solicitar" value="N"/>
            <v-radio label="Solicitar e-mail durante  o pedido" value="S"/>
            <v-radio label="Solicitar e tornar obrigatório a informação do e-mail" value="O" />
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="6" md="6" class="pa-0 pl-3 mb-5 d-flex align-end justify-end">
          <v-btn color="success" @click="salvarConfiguracoes" >
            Salvar Configurações
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import ColorField from "./ColorField.vue";

export default {
  props: ["configuracoes", "id", "empresaToken"],
  data: () => ({
    color: "#FFFFFF",
  }),
  components: {
    ColorField,
  },
  methods: {
    fecharTab() {
      this.$emit("fecharTab");
    },
    async salvarConfiguracoes() {
      try {
        const response = await this.axios.put(`/empresas/${this.id}/configuracoes`,
          this.configuracoes,
          { headers: { Authorization: `Bearer ${this.empresaToken}` } }
        );
        if (response.status == 204) {
          this.fecharTab();
          this.$store.dispatch(
            "showSuccess",
            "Configurações salvas com sucesso!"
          );
        }
      } catch (error) {
        this.$store.dispatch("showError", error);
      }
    },
    setBackgroundColor(cor) {
      this.configuracoes.backgroundColor = cor
    },
    setPrimaryColor(cor) {
      this.configuracoes.primaryColor = cor
    },
    setPromocaoColor(cor) {
      this.configuracoes.promocaoColor = cor
    },
  },
};
</script>

<style>
.configuracoesTitulo {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px;
  margin-left: 1px;
}

.botao-salvar {
  display: flex;
  align-items: flex-end;
}

.cor {
  background-color: lime;
  width: 30px;
  height: 30px;
  border-radius: 18px;
}
</style>